import { useQuery } from "@tanstack/react-query";
import { ApiResponse } from "@/shared/types/api.ts";
import { QUERY_KEYS } from "@/machines/api/config.ts";
import { getGps, IGetGpsInput } from "@/machines/api/requests/gps.requests.ts";
import { Gps } from "@/machines/types/gps.ts";

export const useGetGps = (params: IGetGpsInput) => {

  return useQuery<ApiResponse<Gps[]>>({
    queryKey: [QUERY_KEYS.GPS, params],
    queryFn: () => getGps(params),
    enabled: !!params && !!params.device_mxid
  });
};